import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { map, tap, mapTo, catchError } from "rxjs/operators";

import { CookieService } from "../services/cookie.service";
import { User } from "../models/auth.models";
import { UserLogin } from "../models/user-login";
import { EntryPoints } from "../entrypoints";
import { ObjectResultDto } from "../models/ObjectResult";
import { JwtToken } from "../models/jwt-token";
import { ResetPassword } from "../models/reset-password";

@Injectable({ providedIn: "root" })
export class AuthenticationService extends EntryPoints {
  user: JwtToken;

  constructor(
    private httpClient: HttpClient,
    private cookieService: CookieService,
  ) {
    super();
  }

  /**
   * Returns the current user
   */
  public currentUser(): JwtToken {
    if (!this.user) {
      this.user = JSON.parse(this.cookieService.getCookie("currentUser"));
    }
    return this.user;
  }

  /**
   * Performs the auth
   * @param user user data
   */
  public login(user: UserLogin): Observable<ObjectResultDto> {
    console.log("Start Login");

    const promise = this.httpClient
      .post<ObjectResultDto>(this.loginUrl, user)
      .pipe(
        tap((response: ObjectResultDto) => {
          this.user = response.data;
          this.cookieService.setCookie(
            "currentUser",
            JSON.stringify(response.data),
            1,
          );
          return response;
        }),
      );
    console.log("Observable Created");
    return promise;
  }

  public loginWithRefreshToken(): Observable<ObjectResultDto> {
    const refreshToken = this.currentUser().refresh_token;

    const userInfo = new UserLogin();
    userInfo.refresh_token = refreshToken;
    return this.login(userInfo);
  }

  /**
   * Logout the user
   */
  logout() {
    // remove user from local storage to log user out
    localStorage.clear();
    this.cookieService.deleteCookie("currentUser");
    this.user = null;
  }

  public requestResetPassword(email: string) {
    const promise = this.httpClient.post(this.requestResetPasswordUrl, email);
    return promise;
  }

  public resetPassword(resetPasswordData: ResetPassword) {
    const promise = this.httpClient.post(
      this.requestResetPasswordUrl,
      resetPasswordData,
    );
    return promise;
  }
}
